<template>
  <!--
    주문 한 행의 환불 상태 — 말은 `utils/orderRefund.refundStatusView` 한 곳이고 여기는 그리기만 한다. `NONE` 은 아무것도 그리지
    않는다. `PENDING`(자동 취소 뒤 PG 환불 실패)은 강조하고, 서버가 준 실패 사유가 있으면 그 아래 한 줄로 보인다(hover 전용 정보 없음).
  -->
  <div v-if="view" class="order-refund-status" data-testid="refund-status">
    <el-tag v-if="view.pending" type="danger" size="mini" effect="dark" class="order-refund-status__pending">{{
      $t(view.label)
    }}</el-tag>
    <span v-else>{{ $t(view.label) }}</span>
    <div v-if="view.pending && failReason" class="order-refund-status__reason">{{ failReason }}</div>
  </div>
</template>

<script>
import { refundStatusView } from '@/utils/orderRefund'

export default {
  name: 'OrderRefundStatus',

  props: {
    /** 행의 `refundStatus` — `NONE | PENDING | DONE` */
    status: { type: String, default: null },
    /** 행의 `cancelPayFailReason` — PG 환불 실패 사유(서버 문장) */
    failReason: { type: String, default: null },
  },

  computed: {
    view() {
      return refundStatusView(this.status)
    },
  },
}
</script>

<style scoped>
.order-refund-status {
  line-height: 1.4;
  white-space: normal;
}

.order-refund-status__reason {
  margin-top: 2px;
  font-size: 12px;
  color: #f56c6c;
  word-break: break-all;
}
</style>
